// css =>
import "../../BaseStructure.css";
import Styled from "./project-tittle-box.module.css";

// context =>
import { useTheme } from '../../context/theme-context';

const ProjectTittleBox = (props) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div
            className={`col-2 ${ Styled.ProjectTittleBox } ${ props.selectedItemIndex === props.index ? Styled.active : "" } `}
            onClick={ props.onClick }
            style={{
                borderColor: theme === "day" ? "#474D3D" : ""
            }}>
            <p
                style={{
                    color: theme === "day" ? "#000000" : ""
                }}
            >{ props.projectTittle }</p>
        </div>
    );
}

export default ProjectTittleBox;
